// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__1BrsG","toggleOpacity":"styles_toggleOpacity__DNnlY","closeIcon":"styles_closeIcon__11W-b","popupText":"styles_popupText__3OHu4"};